import React, {Component} from 'react';

import axios from "axios";
import AuthService from "../../AuthService";
import Moment from "moment";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import frLocale from "date-fns/locale/fr";

import logo from "../../img/logo.png";
import loader from "../../img/loader.gif";
import flagEn from "../../img/icon/en.png";
import flagFr from "../../img/icon/fr.png";
import defaultOption from "../../img/icon/default_option.png";
import BankForm from "./BankForm";

import {PhoneInput} from 'react-international-phone';
import 'react-international-phone/style.css';

import {PhoneNumberUtil} from 'google-libphonenumber';

import {CKEditor} from '@ckeditor/ckeditor5-react';
import Editor from '@ckeditor/ckeditor5-build-decoupled-document';

Editor.defaultConfig = {
    toolbar: [ 'fontfamily', 'fontsize', 'fontbackgroundcolor', 'fontcolor', '|', 'bold', 'italic', 'underline', '|','bulletedList', 'numberedList', '|' , 'indent', 'outdent', '|' , 'link', 'blockQuote', '|', 'undo', 'redo' ],
    language: 'fr'
};

class Reservation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            defaultHoursList : ['09:00','09:30','10:00','10:30','11:00','11:30','12:00','12:30','13:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00'],
            locale: "fr",
            step: 1,
            displayBankFacture: false,
            displayBankReservation: false,
            displayBank: false,
            result: null,
            villeList: [],
            inactiveDate: [],
            inactiveHs: [],
            selectedVille: (this.props.match.params.villeId == 1 || this.props.match.params.villeId === undefined  ? 1 : this.props.match.params.villeId),
            displayForm: false,
            data: {},
            formData: {
                isForfait: false,
                tmpDate: Moment().add(2, 'days'),
                limitDate: Moment().add(15, "days"),
                touchCalendar: false,
                showValidateDateMessage : false,
                tmpListHours: [],
                tmpTime: "00:00",
                tmpPrix: "",
                croisiere: {
                    croisiereType: {
                        id: "",
                        label : null
                    },
                    croisiereRamassage: {
                        id: "",
                        label : ""
                    },
                    nombrePassager: "",
                    date: Moment().add(2, 'days').format("DD/MM/YYYY").toString() + " 09:00:00",
                    assuranceMeteo: null,
                    prix: "",
                    clientPrenom: "",
                    clientNom: "",
                    clientTel: "",
                    clientEmail: "",
                    clientSociete: "",
                    clientRefPays: "",
                    clientCodePostal: "",
                    clientVille: "",
                    clientAdresse: "",
                    factureNom: "",
                    factureAdresse: "",
                    factureVille: "",
                    factureCodePostal: "",
                    factureRefPays: "",
                    factureComment: "",
                    comment: ""
                },
                options: [],
                totalOptions: 0
            }
        }

        this.changeForm = this.changeForm.bind(this);
        this.success = this.success.bind(this);
    }

    componentDidMount() {
        this.loadData(false, true);
    }

    async loadData(withBank, loadOptions) {
        this.setState({loading: true});
        let options = [];
        if (loadOptions) {
            this.state.formData.options.forEach((opt, index) => {
                let option = {id: index, nbCharged: opt};
                options.push(option);
            });
        } else {
            this.state.formData.options = [];
            this.state.formData.totalOptions = 0;
        }

        await axios.post(AuthService.getUrl('/getVilles'), {}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                villeList: res.data.data['list']
            });
        });

        await axios.post(AuthService.getUrl('/getInactiveDate'), {villeId: this.state.selectedVille}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                inactiveDate: res.data.data['list']
            });
        });

        await axios.post(AuthService.getUrl('/getInactiveHs'), {villeId: this.state.selectedVille}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                inactiveHs: res.data.data['list']
            });
        });

        await axios.post(AuthService.getUrl("/reservation"), {croisiere: this.state.formData.croisiere, villeId: this.state.selectedVille, options: options, withBank: withBank}, AuthService.getAuthHeader(this.state.locale)).then(res => {
            this.setState({
                result: res.return,
                data: res.data.data
            });
            this.setState(state => {
                const formData = state.formData;
                formData.croisiere.prix = res.data.data.prix;
                formData.isForfait = res.data.data.isForfait;
                formData.prixAssuranceMeteo = !!res.data.data.prixAssuranceMeteo ? res.data.data.prixAssuranceMeteo.toString().slice(0, res.data.data.prixAssuranceMeteo.toString().length-2) + "," + res.data.data.prixAssuranceMeteo.toString().slice(-2) : "";
                formData.prix = !!res.data.data.prix ? res.data.data.prix.toString().slice(0, res.data.data.prix.toString().length-2) + "," + res.data.data.prix.toString().slice(-2) : "";
                formData.totalPrix = !!res.data.data.totalPrix ? res.data.data.totalPrix.toString().slice(0, res.data.data.totalPrix.toString().length-2) + "," + res.data.data.totalPrix.toString().slice(-2) : "";
                formData.halfPrix = !!res.data.data.totalPrix ? (res.data.data.totalPrix / 2).toString().slice(0, (res.data.data.totalPrix / 2).toString().length-2) + "," + (res.data.data.totalPrix / 2).toString().slice(-2) : "";
                if (formData.isForfait != null && formData.isForfait == 'true') {
                    formData.croisiere.nombrePassager = res.data.data.nombrePassager;
                }

                formData.tmpListHours = res.data.data.configDateHours[0].hours;

                // if(this.state.formData.croisiere.assuranceMeteo){
                //         let price = parseInt(formData.prix) || 0;
                //         formData.prix = (price + price*0.10).toString();
                // }
                return {formData : formData};
            });
            this.setState({loading: false});

            if (this.state.selectedVille === 1) {
                let oldData = this.state.data;
                const croisiereRamassage = this.state.data.croisiereRamassages.reverse();
                oldData.croisiereRamassages = croisiereRamassage;
                const newData = oldData;
                this.setState({
                    data: newData
                });
            }
        });
    }

    changeLocale(locale) {
        this.state.locale = locale;
        this.loadData(false, true);
    }

    selectType(typeId, label) {
        this.setState(state => {
            const formData = state.formData;
            formData.croisiere.croisiereType.id = typeId;
            formData.croisiere.croisiereType.label = label;
            return {formData : formData};
        });
        this.loadData(false, true);
        this.setState({step: 2});
    }

    async villeChange(e) {
        e.preventDefault();
        this.setState({isLoading: true});
        let value = e.target.value;
        await this.setState({
            selectedVille: value
        });
        await this.setState(state => {
            const formData = state.formData;
            formData.croisiere.croisiereRamassage.id = (value == 1 || value === undefined ? 2 : 3);
            return {formData : formData};
        });
        this.loadData(false, true);
    }

    selectPassager(e) {
        let value = e.target.value;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiere.nombrePassager = value;
            return {formData : formData};
        }, () => {this.validReservationForm()});
    }

    selectDate(date) {
        this.setState(state => {
            const formData = state.formData;
            formData.tmpDate = date;
            formData.touchCalendar = true;
            if (formData.tmpTime=='') {
                formData.croisiere.date = Moment(date).format("DD/MM/YYYY").toString() + " " + "00:00";
            } else {
                formData.croisiere.date = Moment(date).format("DD/MM/YYYY").toString() + " " + formData.tmpTime + ":00";
            }

            if(formData.limitDate.isAfter(this.state.formData.tmpDate)){
                this.state.formData.croisiere.assuranceMeteo = false;
            }

            return {formData : formData};
        }, () => {this.validReservationForm()});

        const clonedArray = this.state.defaultHoursList.slice();
        this.state.inactiveHs.forEach((infodate, index) => {
            if (Moment(date).format('DD/MM/YYYY') == infodate.date) {
                infodate.hours.forEach((hours, index) => {
                    const indexToRemove = clonedArray.indexOf(hours);
                    if (indexToRemove > -1) { // only splice array when item is found
                        clonedArray.splice(indexToRemove, 1); // 2nd parameter means remove one item only
                    }
                })
            }
        })
        this.addHoursToSelect(clonedArray);
    }

    addHoursToSelect(list) {
        var select = document.getElementById("selectHours");
        while (select.options.length > 0) {
            select.remove(0);
        }

        var opt = document.createElement('option');
        opt.value = '';
        opt.innerHTML = '';
        select.appendChild(opt);

        for (var i=0;i<list.length;i++) {
            var opt = document.createElement('option');
            opt.value = list[i];
            opt.innerHTML = list[i];
            select.appendChild(opt);
        }
    }

    selectHeure(e) {
        let value = e.target.value;
        this.setState(state => {
            const formData = state.formData;
            formData.tmpTime = value;
            formData.croisiere.date = Moment(formData.tmpDate).format("DD/MM/YYYY").toString() + " " + value + ":00";
            return {formData : formData};
        }, () => {this.validReservationForm()});
    }

    selectRamassage(e) {
        let value = e.target.value;
        let label = e.target.options[e.target.options.selectedIndex].text;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiere.croisiereRamassage.id = value;
            formData.croisiere.croisiereRamassage.label = label;
            return {formData : formData};
        }, () => {this.validReservationForm()});
    }

    setAssuranceMeteo(e) {
        let value = e.target.value === "true";
        this.setState(state => {
            const formData = state.formData;
            formData.croisiere.assuranceMeteo = value;
            // const prixAssurance = parseInt(this.state.formData.croisiere.prix.toString().slice(0, this.state.formData.croisiere.prix.toString().length-2) + "," + this.state.formData.croisiere.prix.toString().slice(-2)) * 0.10;
            // if(value){
            //     this.state.formData.prix = (parseInt(this.state.formData.prix) + prixAssurance).toString();
            // } else {
            //     this.state.formData.prix = (parseInt(this.state.formData.prix) - prixAssurance).toString();
            // }
            return {formData: formData};
        } , () => {this.validReservationForm()});
    }

    upOption(name) {
        this.setState(state => {
            const formData = state.formData;
            formData.options[name] = (this.state.formData.options[name] != null ? this.state.formData.options[name] : 0) + 1;
            state.data.croisiereOptions.forEach((opt, index) => {
                if (opt.id === name) {
                    formData.totalOptions = formData.totalOptions + opt.prix;
                }
            });
            return {formData : formData};
        });
    }

    downOption(name) {
        this.setState(state => {
            const formData = state.formData;
            formData.options[name] = this.state.formData.options[name] != null && this.state.formData.options[name] > 0 ? this.state.formData.options[name] - 1 : 0;
            state.data.croisiereOptions.forEach((opt, index) => {
                if (opt.id === name) {
                    formData.totalOptions = formData.totalOptions - opt.prix;
                }
            });

            return {formData : formData};
        });
    }

    goToLastStep(e, loadOption) {
        if (this.state.displayBank) {
            this.setState(state => {
                const data = state.data;
                data.bankResponse = null;
                return {data : data};
            });
        }
        this.loadData(false, loadOption);
        this.setState({step: 4});
    }

    changeForm(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiere[name] = value;
            return {formData : formData};
        }, () => {this.validForm()});
    }

    changeTelClient  = (e) => {
        this.setState(state => {
            const formData = state.formData;
            formData.croisiere["clientTel"] = e;
            return {formData : formData};
        }, () => {this.validForm()});
    }

    displayFacture = () => {
        let value = document.getElementById("facture").checked;
        if (value === true) {
            this.setState({displayBankFacture: true}, () => {this.validForm()});
        } else {
            this.setState({displayBankFacture: false}, () => {this.validForm()});
        }
    }

    validForm() {
        let value = document.getElementById("facture").checked;
        if (value === true) {
            if (this.validFormDetails() && this.validFormFacture()) {
                this.setState({displayBank: true});
            } else {
                this.setState({displayBank: false});
            }

        } else {
            if (this.validFormDetails()) {
                this.setState({displayBank: true});
            } else {
                this.setState({displayBank: false});
            }
        }
    }

    validFormDetails = () => {
        return (!!this.state.formData.croisiere.clientPrenom
            && !!this.state.formData.croisiere.clientNom
            && !!this.state.formData.croisiere.clientEmail
            && !!this.state.formData.croisiere.clientRefPays
            && this.validateEmail(this.state.formData.croisiere.clientEmail)
            && this.validateTelephone(this.state.formData.croisiere.clientTel));
    }

    validFormFacture = () => {
        return (!!this.state.formData.croisiere.factureNom
            && !!this.state.formData.croisiere.factureAdresse
            && !!this.state.formData.croisiere.factureCodePostal
            && !!this.state.formData.croisiere.factureVille
            && !!this.state.formData.croisiere.factureRefPays);
    }

    validReservationForm() {
        this.loadData(false, true);
        if (!!this.state.formData.croisiere.nombrePassager
            && !!this.state.formData.tmpTime
            && !!this.state.formData.croisiere.croisiereRamassage.id
            && (this.state.formData.croisiere.assuranceMeteo != null || this.state.formData.limitDate.isAfter(this.state.formData.tmpDate)))
        {
            this.setState({displayBankReservation: true});
        } else {
            this.setState({displayBankReservation: false});
        }
    }

    validateEmail = (email) => {
        return String(email).trim()
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    validateTelephone = (tel) => {
        const phoneUtil = PhoneNumberUtil.getInstance();
        try {
            return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(tel));
        } catch (e) {
            return false;
        }

    }

    async saveReservation() {
        await axios.post(AuthService.getUrl("/saveReservation"), {croisiere: this.state.formData.croisiere}, AuthService.getAuthHeader()).then(res => {

        });
    }

    success(statusCode) {
        if (statusCode === "00000") {
            this.setState({step: 5});
        }
    }

    disableDays(date, croisiereType) {

        var disabled = true;
        switch (date.getDay()) {
            case 0:
                disabled =  !croisiereType.openedSunday;
                break;
            case 1:
                disabled =  !croisiereType.openedMonday;
                break;
            case 2:
                disabled = !croisiereType.openedTuesday;
                break;
            case 3:
                disabled =  !croisiereType.openedWednesday;
                break;
            case 4:
                disabled =  !croisiereType.openedThursday;
                break;
            case 5:
                disabled =  !croisiereType.openedFriday;
                break;
            case 6:
                disabled =  !croisiereType.openedSaturday;
                break;
        }

        if (!disabled) {
            this.state.inactiveDate.forEach((opt, index) => {
                if (Moment(date).format('DD/MM/YYYY') == opt.date) {
                    disabled = true;
                }
            })
        }
        return disabled;
    }

    goToStep3() {
        if (!this.state.formData.touchCalendar) {
            alert("Veuillez valider la date!")
            return;
        }
        this.setState({step: 3});
    }

    render() {
        if (this.state.result === null) {
            return (
                <React.Fragment>
                    <div id="header">
                        <div id="headerContent">
                            <a href="https://www.greenriver-paris.fr/"><img id="logo" alt="Green River Cruises" src={logo}/></a>
                            <div id="language">
                                <img className="flag" src={flagEn} alt="English"></img>
                                <img className="flag" src={flagFr} alt="French"></img>
                            </div>
                        </div>
                    </div>
                    <div id="frontContent">
                        <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
                    </div>
                    <div id="footer">
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div id="header">
                        <div id="headerContent">
                            <a href="https://www.greenriver-paris.fr/"><img id="logo" alt="Green River Cruises" src={logo}/></a>
                            <div id="language">
                                <img className="flag" src={flagEn} onClick={e => this.changeLocale("en")} alt="English"></img>
                                <img className="flag" src={flagFr} onClick={e => this.changeLocale("fr")} alt="French"></img>
                            </div>
                        </div>
                    </div>
                    <div id="frontContent">
                        {this.state.step === 1 &&
                        <div>
                            <select className="value" type="text" name="villes" value={this.state.selectedVille} onChange={e => this.villeChange(e)}>
                                {this.state.villeList.map(ville => (
                                    <option key={ville.id} value={ville.id}>{ville.nom}</option>
                                ))}
                            </select>

                            <div id="catalog">
                                {this.state.data.croisiereTypes.length !== 0 ? this.state.data.croisiereTypes.map(type => (
                                    <div key={"catalog-item" + type.id} className="catalog-item">
                                        <div className="catalog-item-title">{type.label}</div>
                                        <img className="catalog-item-img" src={"data:image/png;base64," + type.img}/>
                                        <div className="catalog-item-go" onClick={e => this.selectType(type.id, type.label)}>{this.state.data.labels[101]}</div>
                                    </div>
                                )) : 'Aucune croisière disponible à ce jour'}
                            </div>
                        </div>
                        }

                        {this.state.step === 2 &&
                        <div id="calendar">
                            <div className="inlineDiv">
                                <div className="stepBackButton" onClick={() => this.setState({step: 1})}>{this.state.data.labels[1025]}</div>
                            </div>
                            {this.state.data.croisiereTypes.map(type => (
                                <React.Fragment>
                                    {type.id == this.state.formData.croisiere.croisiereType.id &&
                                    <React.Fragment>
                                        <div id="calendar-description">
                                            <div id="calendar-title">{type.label}</div>
                                            <img id="calendar-img" src={"data:image/png;base64," + type.img}/>
                                            <CKEditor
                                                editor={Editor}
                                                data={type.description}
                                                disabled
                                            />
                                        </div>

                                        <div id="calendar-form">
                                            <div id="calendar-form-title">{this.state.data.labels[1015]}</div>
                                            <form>

                                                <div className="label">{this.state.data.labels[1017]}</div>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                                    <DatePicker value={this.state.formData.tmpDate} onChange={date => this.selectDate(date)}
                                                                disableToolbar="true"
                                                                orientation="landscape"
                                                                variant="static"
                                                                openTo="date"
                                                                format="dd/MM/yyyy"
                                                                shouldDisableDate={e => this.disableDays(e, type)}
                                                                minDate={Moment().add(2, 'days')}/>
                                                </MuiPickersUtilsProvider>

                                                <div className="label required">{this.state.data.labels[1018]}</div>
                                                <select id="selectHours" className="value" value={this.state.formData.tmpTime} onChange={e => this.selectHeure(e)}>
                                                    <option value=""></option>
                                                    {this.state.formData.tmpListHours.map(value => (
                                                        <option value={value}>{value}</option>
                                                    ))}
                                                </select>

                                                {this.state.formData.isForfait == null || this.state.formData.isForfait == 'false' &&
                                                <div>
                                                    <div className="label required">{this.state.data.labels[1016]}</div>
                                                    <select className="value" value={this.state.formData.croisiere.nombrePassager} onChange={e => this.selectPassager(e)}>
                                                        <option value=""></option>
                                                        {[...Array(type.passengerLimit)].map((limit, index) => (
                                                            <option value={limit}>{index + 1}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                }

                                                <div className="label required">{this.state.data.labels[1019]}</div>
                                                <select className="value" onChange={e => this.selectRamassage(e)}>
                                                    <option key={""} value={""}></option>
                                                    {this.state.data.croisiereRamassages.map(ramassage => (
                                                        <option key={ramassage.id} value={ramassage.id}>{ramassage.label}</option>
                                                    ))}
                                                </select>


                                                {this.state.formData.limitDate.isBefore(this.state.formData.tmpDate) && (
                                                    <div className="info-container">
                                                        <div className="assurance-meteo">
                                                            <div
                                                                className="label required info-label">{this.state.data.labels[1144]}</div>
                                                        </div>

                                                        <div className="tooltip-wrapper">
                                                            <span className="info-icon">?</span>

                                                            <div className="tooltip-box">
                                                                <strong>{this.state.data.labels[1149]}</strong>
                                                                <ul>
                                                                    <li>{this.state.data.labels[1150]}</li>
                                                                    <li>{this.state.data.labels[1151]}</li>
                                                                    <li>{this.state.data.labels[1152]} <a style={{color: 'blue', fontWeight:700}} href="/files/GarantieMeteoGreenRiverCruise.pdf" download>{this.state.data.labels[1153]}</a>.</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {this.state.formData.limitDate.isBefore(this.state.formData.tmpDate) && (
                                                    <div style={{marginTop: "10px"}}>
                                                        <input type={"radio"} name={"assurance"} value="true"
                                                               checked={this.state.formData.croisiere.assuranceMeteo === true}
                                                               onChange={e => this.setAssuranceMeteo(e)}/> {this.state.data.labels[1147]}
                                                        <input type={"radio"} name={"assurance"} value="false"
                                                               checked={this.state.formData.croisiere.assuranceMeteo === false}
                                                               onChange={e => this.setAssuranceMeteo(e)}/> {this.state.data.labels[1146]}
                                                    </div>
                                                )}

                                                <div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>
                                                    <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1020]}</div>
                                                    <div className="confirm-details-cell" style={{"width": "180px", "textAlign": "right", "fontSize": "20px"}}>{this.state.formData.totalPrix} €</div>
                                                </div>


                                                {!this.state.data.bankResponse && !this.state.displayBankReservation &&
                                                <div className="validButton" style={{"width": "calc(100% - 60px)", "fontSize": "15px", "background": "#B9B9B9"}}>
                                                    <span style={{"color": "#888888"}}>{this.state.data.labels[1021]}</span><br/>
                                                    <span style={{"fontSize": "12px"}}>{!this.state.displayBank && this.state.data.labels[1042]}</span>
                                                </div>
                                                }
                                                {!this.state.data.bankResponse && this.state.displayBankReservation && !this.state.loading &&
                                                <button type="button" className="validButton" style={{"fontSize": "15px"}} onClick={() => this.goToStep3()}>{this.state.data.labels[1021]}</button>
                                                }
                                                {!this.state.data.bankResponse && this.state.displayBankReservation && this.state.loading &&
                                                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
                                                }

                                            </form>
                                        </div>
                                    </React.Fragment>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                        }

                        {this.state.step === 3 &&
                        <div id="option">
                            <div className="topBar">
                                <div className="leftZone">
                                    <div className="stepBackButton" onClick={() => this.setState({ step: 2 })}>
                                        {this.state.data.labels[1025]}
                                    </div>
                                    <div id="option-title">{this.state.data.labels[1022]}</div>
                                </div>

                                <div className="rightZone">
                                    <button
                                        type="button"
                                        className="validButton"
                                        onClick={e => this.goToLastStep(e, true)}
                                    >
                                        {this.state.data.labels[1024]}
                                    </button>

                                    <button
                                        type="button"
                                        className="ignoreBackButton"
                                        onClick={e => this.goToLastStep(e, false)}
                                    >
                                        {this.state.data.labels[1023]}
                                    </button>
                                </div>
                            </div>
                            {this.state.data.categorieExtra.map(categorie => (
                                <React.Fragment>
                                    <div id="option-categorie">{categorie.label}</div>
                                    {categorie.id === 2 &&
                                    <div id="option-slogan">{this.state.data.labels[1121]}</div>
                                    }
                                    <div id="option-liste">
                                        {this.state.data.croisiereOptions.map(option => (
                                            <React.Fragment>
                                                {option.categorieExtra.id === categorie.id &&
                                                <div className="option">
                                                    <img className="option-img" src={!!option.img ? "data:image/png;base64," + option.img : defaultOption}/>
                                                    <div className="option-text-detail" style={{"width": "100%","margin": "0px 20px"}}>
                                                        <div className="option-label">{option.label}</div>
                                                        <div className="option-description">{option.labelDescription}</div>
                                                    </div>
                                                    <div className="option-detail">
                                                        <div className="option-price">{option.prix.toString().slice(0, option.prix.toString().length-2) + "," + option.prix.toString().slice(-2)} €</div>
                                                        <div className="option-value">
                                                            <button type="button" className="option-control" style={{borderRadius: "35px 0px 0px 35px"}} onClick={() => this.downOption(option.id)}>-</button>
                                                            <input type="text"
                                                                   className="option-input"
                                                                   autoComplete="off"
                                                                   readOnly="readOnly"
                                                                   name={"option-" + option.id}
                                                                   value={this.state.formData.options[option.id] != null ? this.state.formData.options[option.id] : 0}/>
                                                            <button type="button" className="option-control" style={{borderRadius: "0px 35px 35px 0px"}} onClick={() => this.upOption(option.id)}>+</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </React.Fragment>
                            ))}

                            <div className="topBar">
                                <div className="leftZone">
                                    <button type="button" className="ignoreBackButton" style={{"fontSize": "15px"}} onClick={e => this.goToLastStep(e, false)}>{this.state.data.labels[1023]}</button>
                                </div>

                                <div className="rightZone1">
                                    <div style={{"text-align": "right"}}>
                                        <button type="button" className="validButton" style={{"fontSize": "15px"}} onClick={e => this.goToLastStep(e, true)}>{this.state.data.labels[1024]}</button>
                                    </div>
                                    <div style={{"text-align": "right", "padding-top" : "10px"}}>
                                        <button type="button" className="ignoreBackButton" style={{"fontSize": "15px"}} onClick={e => this.goToLastStep(e, false)}>{this.state.data.labels[1023]}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        {this.state.step === 4 &&
                        <div id="confirm">
                            <div className="inlineDiv">
                                <div className="stepBackButton" onClick={() => this.setState({step: 3})}>{this.state.data.labels[1025]}</div>
                            </div>

                            <div id="confirm-form">
                                <div id="confirm-form-title">{this.state.data.labels[1026]}</div>
                                <form>

                                    <div className="label required">{this.state.data.labels[1028]}</div>
                                    <input className="value" type="text" name="clientNom" value={this.state.formData.croisiere.clientNom} onChange={this.changeForm} />

                                    <div className="label required">{this.state.data.labels[1027]}</div>
                                    <input className="value" type="text" name="clientPrenom" value={this.state.formData.croisiere.clientPrenom} onChange={this.changeForm} />

                                    <div className="label required">{this.state.data.labels[1029]}</div>
                                    <PhoneInput
                                        defaultCountry="fr"
                                        value={this.state.formData.croisiere.clientTel}
                                        onChange={this.changeTelClient}
                                    />

                                    <br />

                                    <div className="label required">{this.state.data.labels[1030]}</div>
                                    <input className="value" type="text" name="clientEmail" value={this.state.formData.croisiere.clientEmail} onChange={this.changeForm} />

                                    <br />

                                    <div className="label"><input type="checkbox" id="facture" onClick={this.displayFacture} value={this.state.displayBankFacture} /> {this.state.data.labels[107]} </div>

                                    <br />

                                    <div className="label required">{this.state.data.labels[1034]}</div>
                                    {this.state.locale == 'fr' &&
                                    <select className="value" type="text" name="clientRefPays" value={this.state.formData.croisiere.clientRefPays} onChange={this.changeForm} style={{"width": "100%"}}>
                                        <option></option>
                                        {this.state.data.pays.map(pay => (
                                            <option key={pay.id} value={pay.id}>{pay.label}</option>
                                        ))}
                                    </select>
                                    }

                                    {this.state.locale == 'en' &&
                                    <select className="value" type="text" name="clientRefPays" value={this.state.formData.croisiere.clientRefPays} onChange={this.changeForm} style={{"width": "100%"}}>
                                        <option></option>
                                        {this.state.data.pays.map(pay => (
                                            <option key={pay.id} value={pay.id}>{pay.labelEn}</option>
                                        ))}
                                    </select>
                                    }


                                    <div className="label">{this.state.data.labels[1036]}</div>
                                    <textarea className="value" type="text" name="comment" value={this.state.formData.croisiere.comment} onChange={this.changeForm} style={{"height": "100px"}} />

                                    {!this.state.data.bankResponse && !this.state.displayBank &&
                                    <div className="validButton" style={{"width": "calc(100% - 60px)", "fontSize": "15px", "background": "#B9B9B9"}}>
                                        <span style={{"color": "#888888"}}>{this.state.data.labels[1041]}</span><br/>
                                        <span style={{"fontSize": "12px"}}>{!this.state.displayBank && this.state.data.labels[1042]}</span>
                                    </div>
                                    }
                                    {!this.state.data.bankResponse && this.state.displayBank && !this.state.loading &&
                                    <div className="validButton" style={{"width": "calc(100% - 60px)", "fontSize": "15px"}} onClick={() => this.setState({displayForm: true})}>{this.state.data.labels[1041]}</div>
                                    }
                                    {!this.state.data.bankResponse && this.state.displayBank && this.state.loading &&
                                    <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
                                    }

                                </form>

                                {this.state.displayBank && this.state.displayForm &&
                                <React.Fragment>
                                    <div id="confirm-form-title">Paiement</div>
                                    <BankForm formData={this.state.formData}
                                              villeId={this.state.selectedVille}
                                              success={this.success}
                                              croisiereOptions={this.state.data.croisiereOptions}
                                    ></BankForm>
                                </React.Fragment>
                                }
                            </div>

                            <div id="right">
                                <div id="confirm-details">
                                    <div id="confirm-details-title" onClick={e => this.saveReservation(e)}>{this.state.data.labels[1037]}</div>
                                    <form style={{"padding": "20px"}}>
                                        {this.state.data.croisiereTypes.map(type => (
                                            <React.Fragment>
                                                {type.id == this.state.formData.croisiere.croisiereType.id &&
                                                <div>
                                                    <div className="confirm-details-line-blank">
                                                        <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[102]} <span style={{"font-weight" : "bold"}}>{type.label}</span></div>
                                                        <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{this.state.formData.croisiere.prix.toString().slice(0, this.state.formData.croisiere.prix.toString().length-2) + "," + this.state.formData.croisiere.prix.toString().slice(-2)} €</div>
                                                    </div>

                                                    {this.state.locale == 'fr' &&
                                                    <div className="confirm-details-line-details-blank">
                                                        <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[103]}{" : "}</span>
                                                            {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY hh:mm:ss").locale("fr").format("dddd Do MMMM").toString()}</div>
                                                    </div>
                                                    }

                                                    {this.state.locale == 'en' &&
                                                    <div className="confirm-details-line-details-blank">
                                                        <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[103]}{" : "}</span>
                                                            {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY hh:mm:ss").locale("en").format("dddd Do MMMM").toString()}</div>
                                                    </div>
                                                    }


                                                    <div className="confirm-details-line-details-blank">
                                                        <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[104]}{" : "}</span>
                                                            {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY HH:mm:ss").format("HH[H]mm").toString()} {" - "}
                                                            {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY HH:mm:ss").add(type.duree, 'hours').format("HH[H]mm").toString()}</div>
                                                    </div>
                                                    <div className="confirm-details-line-details-blank">
                                                        <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[1016]}{" : "}</span>
                                                            {this.state.formData.croisiere.nombrePassager}</div>
                                                    </div>
                                                    <div className="confirm-details-line-details-blank">
                                                        <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[105]}{" : "}</span>
                                                            {this.state.formData.croisiere.croisiereRamassage.label}</div>
                                                    </div>

                                                    <div className="confirm-details-line-details-blank" style={{"height" : "10px"}}></div>
                                                </div>
                                                }
                                            </React.Fragment>
                                        ))}

                                        {this.state.formData.totalOptions > 0 &&
                                        <div className="confirm-details-line-details-blank">
                                            <div className="confirm-details-cell" style={{"width": "180px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[106]}{" : "}</span></div>
                                            <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{(this.state.formData.totalOptions).toString().slice(0, (this.state.formData.totalOptions).toString().length-2) + "," + (this.state.formData.totalOptions).toString().slice(-2)} €</div>
                                        </div>
                                        }

                                        {this.state.data.croisiereOptions.map(option => (
                                            <React.Fragment>
                                                {this.state.formData.options.map((opt, index) => (
                                                    <React.Fragment>
                                                        {index == option.id &&
                                                        <div className="confirm-details-line-details-blank">
                                                            <span style={{"font-size" : "15px"}}>{"⁃   "}{option.label} {" - x"} {opt}</span>
                                                        </div>
                                                        }
                                                    </React.Fragment>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                        <div className="confirm-details-line-details-blank">
                                            <div className="confirm-details-cell" style={{"width": "200px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[1144]}{" : "}</span>
                                                {this.state.formData.croisiere.assuranceMeteo ? "Oui" : "Non"}</div>
                                            <div className="confirm-details-cell" style={{"width": "200px", "textAlign": "right"}}>{this.state.formData.croisiere.assuranceMeteo ? this.state.formData.prixAssuranceMeteo : "0,00"} €</div>
                                        </div>

                                        <div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>
                                            <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1038]}</div>
                                            <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right", "fontSize": "20px"}}>{this.state.formData.totalPrix} €</div>
                                        </div>
                                        <div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>
                                            <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1039]}</div>
                                            <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{this.state.formData.totalPrix} €</div>
                                        </div>
                                        {/*<div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>*/}
                                        {/*    <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1040]}</div>*/}
                                        {/*    <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{this.state.formData.halfPrix} €</div>*/}
                                        {/*</div>*/}
                                    </form>
                                </div>

                                <div id="blank" style={{"height":"20px"}}></div>

                                {this.state.displayBankFacture &&
                                <div id="facture-form">
                                    <div id="confirm-form-title">{this.state.data.labels[1026]}</div>
                                    <form>
                                        <div className="label required">{this.state.data.labels[108]}</div>
                                        <input className="value" type="text" name="factureNom" value={this.state.formData.croisiere.factureNom} onChange={this.changeForm} />
                                        <div className="label required">{this.state.data.labels[1032]}</div>
                                        <input className="value" type="text" name="factureAdresse" value={this.state.formData.croisiere.factureAdresse} onChange={this.changeForm} />
                                        <div className="label required">{this.state.data.labels[1033]}</div>
                                        <input className="value" type="text" name="factureVille" value={this.state.formData.croisiere.factureVille} onChange={this.changeForm} />

                                        <div className="label required">{this.state.data.labels[1035]}</div>
                                        <input className="value" type="text" name="factureCodePostal" value={this.state.formData.croisiere.factureCodePostal} onChange={this.changeForm} />

                                        <div className="label required">{this.state.data.labels[1034]}</div>

                                        {this.state.locale == 'fr' &&
                                        <select className="value" type="text" name="factureRefPays" value={this.state.formData.croisiere.factureRefPays} onChange={this.changeForm} style={{"width": "100%"}}>
                                            <option></option>
                                            {this.state.data.pays.map(pay => (
                                                <option key={pay.id} value={pay.id}>{pay.label}</option>
                                            ))}
                                        </select>
                                        }

                                        {this.state.locale == 'en' &&
                                        <select className="value" type="text" name="factureRefPays" value={this.state.formData.croisiere.factureRefPays} onChange={this.changeForm} style={{"width": "100%"}}>
                                            <option></option>
                                            {this.state.data.pays.map(pay => (
                                                <option key={pay.id} value={pay.id}>{pay.labelEn}</option>
                                            ))}
                                        </select>
                                        }

                                        <div className="label">{this.state.data.labels[1036]}</div>
                                        <textarea className="value" type="text" name="factureComment" value={this.state.formData.croisiere.factureComment} onChange={this.changeForm} style={{"height": "100px"}} />
                                    </form>
                                </div>
                                }
                            </div>
                        </div>
                        }

                        {this.state.step === 5 &&
                        <div id="confirm">
                            <div className="inlineDiv">
                                <a className="stepBackButton" href="https://www.greenriver-paris.fr/">Quitter</a>
                            </div>

                            <div id="confirm-form">
                                <div id="confirm-form-title">{this.state.data.labels[1026]}</div>
                                <form>
                                    <div className="label">{this.state.data.labels[109]} {" : "}</div>
                                    <div className="label">{this.state.formData.croisiere.clientPrenom}</div>
                                    <div className="label">{this.state.formData.croisiere.clientNom}</div>
                                    <div className="label">{this.state.formData.croisiere.clientTel}</div>
                                    <div className="label">{this.state.formData.croisiere.clientEmail}</div>
                                    <br/>
                                    <div className="label">{this.state.formData.croisiere.clientSociete}</div>
                                    <div className="label">{this.state.formData.croisiere.clientAdresse}</div>
                                    <div className="label">{this.state.formData.croisiere.clientVille}</div>
                                    <div className="label">{this.state.formData.croisiere.clientCodePostal}</div>
                                    {this.state.locale == 'fr' &&
                                    <div className="label">
                                        {this.state.data.pays.map(pay => (
                                            <React.Fragment>
                                                {pay.id == this.state.formData.croisiere.clientRefPays &&
                                                pay.label
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    }
                                    {this.state.locale == 'en' &&
                                    <div className="label">
                                        {this.state.data.pays.map(pay => (
                                            <React.Fragment>
                                                {pay.id == this.state.formData.croisiere.clientRefPays &&
                                                pay.label_en
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    }

                                    {this.state.displayBankFacture &&
                                    <div>
                                        <div className="label" style={{"height" : "10px"}}></div>
                                        <div className="label">{this.state.data.labels[110]} {" : "}</div>
                                        <div className="label">{this.state.formData.croisiere.factureNom}</div>
                                        <div className="label">{this.state.formData.croisiere.factureAdresse}</div>
                                        <div className="label">{this.state.formData.croisiere.factureVille}</div>
                                        <div className="label">{this.state.formData.croisiere.factureCodePostal}</div>
                                        {this.state.locale == 'fr' &&
                                        <div className="label">
                                            {this.state.data.pays.map(pay => (
                                                <React.Fragment>
                                                    {pay.id == this.state.formData.croisiere.factureRefPays &&
                                                    pay.label
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </div>
                                        }
                                        {this.state.locale == 'en' &&
                                        <div className="label">
                                            {this.state.data.pays.map(pay => (
                                                <React.Fragment>
                                                    {pay.id == this.state.formData.croisiere.factureRefPays &&
                                                    pay.label_en
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </div>
                                        }
                                    </div>
                                    }

                                    <div className="validButton" style={{"width": "calc(100% - 60px)", "marginTop": "10px", "fontSize": "18px", "background": "#009026"}}>
                                        <span>{this.state.data.labels[111]}</span><br/>
                                        <span style={{"fontSize": "14px"}}>{this.state.data.labels[112]}</span>
                                    </div>
                                </form>
                            </div>

                            <div id="confirm-details">
                                <div id="confirm-details-title" onClick={e => this.saveReservation(e)}>{this.state.data.labels[1037]}</div>
                                <form style={{"padding": "20px"}}>
                                    {this.state.data.croisiereTypes.map(type => (
                                        <React.Fragment>
                                            {type.id == this.state.formData.croisiere.croisiereType.id &&
                                            <div>
                                                <div className="confirm-details-line-blank">
                                                    <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[102]} <span style={{"font-weight" : "bold"}}>{type.label}</span></div>
                                                    <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{this.state.formData.croisiere.prix.toString().slice(0, this.state.formData.croisiere.prix.toString().length-2) + "," + this.state.formData.croisiere.prix.toString().slice(-2)} €</div>
                                                </div>
                                                <div className="confirm-details-line-details-blank">
                                                    <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[103]}{" : "}</span>
                                                        {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY hh:mm:ss").format("dddd Do MMMM").toString()}</div>
                                                </div>
                                                <div className="confirm-details-line-details-blank">
                                                    <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[104]}{" : "}</span>
                                                        {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY HH:mm:ss").format("HH[H]mm").toString()} {" - "}
                                                        {Moment(this.state.formData.croisiere.date, "DD/MM/YYYY HH:mm:ss").add(type.duree, 'hours').format("HH[H]mm").toString()}</div>
                                                </div>
                                                <div className="confirm-details-line-details-blank">
                                                    <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[1016]}{" : "}</span>
                                                        {this.state.formData.croisiere.nombrePassager}</div>
                                                </div>
                                                <div className="confirm-details-line-details-blank">
                                                    <div className="confirm-details-cell" style={{"width": "400px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[105]}{" : "}</span>
                                                        {this.state.formData.croisiere.croisiereRamassage.label}</div>
                                                </div>
                                                <div className="confirm-details-line-details-blank" style={{"height" : "10px"}}></div>
                                            </div>
                                            }
                                        </React.Fragment>
                                    ))}

                                    {this.state.formData.totalOptions > 0 &&
                                    <div className="confirm-details-line-details-blank">
                                        <div className="confirm-details-cell" style={{"width": "180px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[106]}{" : "}</span></div>
                                        <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{(this.state.formData.totalOptions).toString().slice(0, (this.state.formData.totalOptions).toString().length-2) + "," + (this.state.formData.totalOptions).toString().slice(-2)} €</div>
                                    </div>
                                    }

                                    {this.state.data.croisiereOptions.map(option => (
                                        <React.Fragment>
                                            {this.state.formData.options.map((opt, index) => (
                                                <React.Fragment>
                                                    {index == option.id &&
                                                    <div className="confirm-details-line-details-blank">
                                                        <span style={{"font-size" : "15px"}}>{"⁃   "}{option.label} {" - x"} {opt}</span>
                                                    </div>
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </React.Fragment>
                                    ))}

                                    <div className="confirm-details-line">
                                        <div className="confirm-details-cell" style={{"width": "200px"}}><span style={{"font-weight" : "bold"}}>{this.state.data.labels[1144]}{" : "}</span>
                                            {this.state.formData.croisiere.assuranceMeteo ? "Oui" : "Non"}</div>
                                        <div className="confirm-details-cell" style={{"width": "200px", "textAlign": "right"}}>{this.state.formData.croisiere.assuranceMeteo ? this.state.formData.prixAssuranceMeteo : "0,00"} €</div>
                                    </div>
                                    <div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>
                                        <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1038]}</div>
                                        <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right", "fontSize": "20px"}}>{this.state.formData.totalPrix} €</div>
                                    </div>
                                    <div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>
                                        <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1039]}</div>
                                        <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{this.state.formData.totalPrix} €</div>
                                    </div>
                                    {/*<div className="confirm-details-line" style={{"fontFamily": "'SourceSansPro-bold'"}}>*/}
                                    {/*    <div className="confirm-details-cell" style={{"width": "180px"}}>{this.state.data.labels[1040]}</div>*/}
                                    {/*    <div className="confirm-details-cell" style={{"width": "220px", "textAlign": "right"}}>{this.state.formData.halfPrix} €</div>*/}
                                    {/*</div>*/}
                                </form>
                            </div>
                        </div>
                        }
                    </div>
                    <div id="footer">
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default Reservation;